import { isEmptyString } from '../isEmptyString';

// Matches LinkedIn URLs with no subdomain, www, or short regional subdomains (e.g. uk.linkedin.com).
export const LINKEDIN_URL_REGEX =
  /^https?:\/\/((www|[a-z]{2})\.)?linkedin\.com\/.+$/i;

export function validateLinkedinUrl(value?: string) {
  if (isEmptyString(value)) return;

  if (!LINKEDIN_URL_REGEX.test(value)) {
    return 'Enter a valid LinkedIn URL';
  }
}
